import { Divider, Typography } from '@mui/material';
import { Modal, ModalActions, ModalContent, ModalProps } from '../../../Modal';
import { AdminInsuranceDetails } from './admin-insurance-details';
import { makeStyles } from 'tss-react/mui';
import { Button } from '../../../Button';
import { Tooltip } from '../../../Tooltip';
import { InsuranceDataType } from '../Settings/types';
import { CalendarDateService } from '@uplift/services';
import { getArchiveReasonLabel } from '@uplift/api';

export type ArchivedInsuranceDetailsModalProps = {
  insuranceDetails: InsuranceDataType;
  onOpenRestoreModal: () => void;
  restoreDisabledReason: string | null;
} & ModalProps;

export const ArchivedInsuranceDetailsModal: React.FC<ArchivedInsuranceDetailsModalProps> = ({
  insuranceDetails,
  onOpenRestoreModal,
  restoreDisabledReason,
  ...props
}) => {
  const { classes: modalClasses } = useModalStyles();

  const createdAt = CalendarDateService.date(insuranceDetails.createdAt).tz(CalendarDateService.timezones.ET).format('M/D/YYYY, h:mm A ET');
  const archivedAt = CalendarDateService.date(insuranceDetails.archivedAt).tz(CalendarDateService.timezones.ET).format('M/D/YYYY, h:mm A ET');

  return (
    <Modal
      title="Archived Insurance"
      maxWidth="md"
      fullWidth
      classes={modalClasses}
      {...props}
    >
      <ModalContent dividers>
        <div>
          <Typography variant="overline" color="secondary" mb={1}>History</Typography>
          <Typography variant="body2" color="text.primary" mb={1}>Added by {insuranceDetails?.createdByFullName} on {createdAt}</Typography>
          <Typography variant="body2" color="text.primary">Archived by {insuranceDetails?.archivedByFullName} on {archivedAt}</Typography>
          {insuranceDetails?.archiveReason && <Typography variant="body2">{getArchiveReasonLabel(insuranceDetails?.archiveReason)}</Typography>}
        </div>
        <Divider sx={{ my: 4 }} />
        <div>
          <AdminInsuranceDetails insuranceData={insuranceDetails} />
        </div>
      </ModalContent>
      <ModalActions>
        <Tooltip arrow={false} placement="top" title={restoreDisabledReason ?? null}>
          <div>
            <Button disabled={restoreDisabledReason} color="secondary" variant="contained" onClick={() => onOpenRestoreModal()}>
              Restore Insurance
            </Button>
          </div>
        </Tooltip>
      </ModalActions>
    </Modal>
  );
};

const useModalStyles = makeStyles()({
  paperWidthMd: {
    width: '600px',
    maxWidth: '600px'
  },
});
